/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PianificazioneResDto } from '../../models/pianificazione-res-dto';

export interface PianificazioniControllerGetOnePianificazioneById$Params {
  id: number;
}

export function pianificazioniControllerGetOnePianificazioneById(
  http: HttpClient,
  rootUrl: string,
  params: PianificazioniControllerGetOnePianificazioneById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    pianificazioniControllerGetOnePianificazioneById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PianificazioneResDto>;
      }),
    );
}

pianificazioniControllerGetOnePianificazioneById.PATH =
  '/admin/pianificazioni/id/{id}';
